export default __webpack_public_path__ + "static/media/techcamp.c5038eb9.png";